(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    const csCloseTimers = new WeakMap();
  const csHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const csCloseOthers = (current) => {
    document.querySelectorAll('.cs-dropdown[open]').forEach((menu) => {
      if (menu !== current) menu.open = false;
    });
  };
  document.addEventListener('pointerover', (event) => {
    if (!csHover.matches || event.pointerType === 'touch') return;
    const menu = event.target.closest('.cs-dropdown');
    if (!menu) return;
    clearTimeout(csCloseTimers.get(menu));
    if (menu.contains(event.relatedTarget)) return;
    csCloseOthers(menu);
    menu.open = true;
  });
  document.addEventListener('pointerout', (event) => {
    if (!csHover.matches || event.pointerType === 'touch') return;
    const menu = event.target.closest('.cs-dropdown');
    if (!menu || menu.contains(event.relatedTarget)) return;
    clearTimeout(csCloseTimers.get(menu));
    csCloseTimers.set(menu, setTimeout(() => {
      if (!menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;
    }, 180));
  });
  document.addEventListener('focusout', (event) => {
    const menu = event.target.closest('.cs-dropdown');
    if (menu && !menu.contains(event.relatedTarget) && !menu.matches(':hover')) menu.open = false;
  });
  document.addEventListener('click', (event) => {
    csCloseOthers(event.target.closest('.cs-dropdown'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cs-dropdown[open]').forEach((menu) => {
      clearTimeout(csCloseTimers.get(menu));
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
      menu.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
